import { initContract } from '@ts-rest/core';
import { adminTokenContract } from './token.admin.contract';
import { authTokenContract } from './token.auth.contract';
import { publicTokenContract } from './token.public.contract';

const c = initContract();

export const tokenContract = c.router(
  {
    admin: adminTokenContract,
    auth: authTokenContract,
    public: publicTokenContract,
  },
  {
    pathPrefix: '/token',
    strictStatusCodes: true,
  }
);

export * from './models';
export * from './token.admin.contract';
export * from './token.auth.contract';
export * from './token.public.contract';

